define('cart_promocode_notifications.tpl', ['Handlebars','Handlebars.CompilerNameLookup'], function(Handlebars, _nl_){
	return _wrap_fn_('cart_promocode_notifications', {"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    return " ";
},"useData":true}, 'extensions/RSM/WestAcademic_Theme/1.0.0/', 'extensions/RSM/WestAcademic_Theme/1.0.0/', Handlebars);
});